import * as types from './mutations-type'

export const setCronLogId = function({commit}, payload) {
    commit(types.CRON_LOG_ID, payload)
}

export const setPage = function({commit}, payload) {
    commit(types.PAGE , payload)
}

export const setPerPage = function({commit}, payload) {
    commit(types.PERPAGE , payload)
}

export const setTotLog = function({commit}, payload) {
    commit(types.LOG_COUNTS , payload)
}

export const setLastPage = function({commit}, payload) {
    commit(types.LAST_PAGE, payload) 
}

export const setResponsePayload = function({commit}, payload) {
    commit(types.RESPONSE_PAYLOAD, payload)
}

